import { Component, OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { SolicitationStatusModel } from 'src/app/shared/models/solicitation-status.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-portal-operator-summary',
  templateUrl: './portal-operator-summary.component.html',
  styleUrls: ['./portal-operator-summary.component.scss'],
})
export class PortalOperatorSummaryComponent implements OnInit {

  stepsList: string[];
  descriptionsList: string[];
  temporalProducts: any[];
  dateLabels: any[];
  solicitationInfo: SolicitationStatusModel;
  generalState = '';
  detailsText = '';
  currentStep = 0;
  stateList: string[];
  productsOrder: string[];
  productsName: {};
  subproductsName: {};
  rejectedDocuments: any[];
  anacreResponse = '';
  creationDate: string;
  documentsUploaded = false;
  creditGrayZone = true;

  constructor(
    private abrecuentasService: AbreCuentasService,
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private parameterService: ParametersService,
    private captureService: CaptureService,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    console.log('this.copyService.copies.portal_operator_summary');
    console.log(this.copyService.copies.portal_operator_summary);
    this.listsInitialization();
  }

  next(code: number) {
    /* istanbul ignore else */
    if (code === 202) {
      this.taggEvent('2');
      this.captureService.documentarySufficiency(this.solicitationInfo.prospects[0].economic_activity, this.solicitationInfo.solicitation_type).then(res => {
        if (res.code === '200') {
          let list: any[] = res.data;
          list = list.filter(doc => doc.required_ind).map(doc => ({ ...doc, isFileSizeCorrect: true, isFileTypeCorrect: true }));
          this.abrecuentasService.setDocumentarySufficiencyList(list);
          this.navigationService.nextStep(code.toString());
        }
      });
    } else if (code === 200) {
      this.taggEvent('3');
      this.navigationService.nextStep(code.toString());
    } else if (code === 201) {
      this.navigationService.nextStep(code.toString());
    }
  }

  async listsInitialization() {
    this.stepsList = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).stepsList;
    this.stateList = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).stateList;
    this.productsOrder = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).productsOrder;
    this.productsName = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).productsName;
    this.subproductsName = this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).subproductsName;
    this.setInitialInfo();
  }

  async setInitialInfo() {
    this.documentsUploaded = this.abrecuentasService.getDocumentsUploaded();
    if (this.documentsUploaded) {
      setTimeout(() => {
        this.taggEvent('4', this.copyService.copies.portal_operator_summary.documents_succesfull);
      }, 500);
    }
    this.abrecuentasService.setDocumentsUploaded(false);
    this.solicitationInfo = this.abrecuentasService.getRequestModel();
    this.solicitationInfo = {
      ...this.solicitationInfo,
      dates: [],
    };
    console.log('this.solicitationInfo');
    console.log(this.solicitationInfo);
    this.setPhasesDates();
    this.setProductState();
    this.setDetailsText();
    this.getRejectedDocuments();
  }

  setProductState() {
    const status = this.solicitationInfo.solicitation_status;
    const phase = this.solicitationInfo.solicitation_phase;
    console.log(this.anacreResponse);
    if ((phase === '11' && status === '10') ||
    (phase === '04' && (this.anacreResponse === 'NEGADO' || this.anacreResponse === 'DEVUELTO'))) {
      this.generalState = 'Rechazado';
    } else if (phase === '10' || ((phase === '04' || phase === '09') && this.anacreResponse === 'APROBADO')) {
      this.generalState = 'Aprobado';
    } else {
      this.generalState = 'En proceso';
    }
  }

  setDetailsText() {
    if (this.generalState === 'Aprobado') {
      this.detailsText = this.solicitationInfo.dates[3] ?
        this.copyService.copies.portal_operator_summary.details_description_9
          : this.copyService.copies.portal_operator_summary.details_description_8;
    } else if (this.generalState === 'En proceso') {
      this.detailsText =
        this.solicitationInfo.dates[2] ? this.copyService.copies.portal_operator_summary.details_description_6
          : this.solicitationInfo.dates[1] ? this.copyService.copies.portal_operator_summary.details_description_5
            : this.copyService.copies.portal_operator_summary.details_description_1;
    } else {
      this.detailsText =
        this.solicitationInfo.dates[2] ? (!this.creditGrayZone ?
          this.copyService.copies.portal_operator_summary.details_description_10
          : this.copyService.copies.portal_operator_summary.details_description_7)
          : this.solicitationInfo.dates[1] ? this.copyService.copies.portal_operator_summary.details_description_4
            : this.copyService.copies.portal_operator_summary.details_description_3;
    }
    if (!this.solicitationInfo.products) {
      this.solicitationInfo.products = [];
    }
    this.setProductOrder();
    if (this.solicitationInfo.products.length <= 1) { return; }
    switch (this.detailsText) {
      case this.copyService.copies.portal_operator_summary.details_description_6:
        this.detailsText = this.copyService.copies.portal_operator_summary.details_description_6_multiproduct;
        break;
      case this.copyService.copies.portal_operator_summary.details_description_8:
        this.detailsText = this.copyService.copies.portal_operator_summary.details_description_8_multiproduct;
        break;
      case this.copyService.copies.portal_operator_summary.details_description_9:
        this.detailsText = this.copyService.copies.portal_operator_summary.details_description_9_multiproduct;
        break;
    }
  }

  setPhasesDates() {
    const solicitationPhase = this.solicitationInfo.solicitation_phase;
    if (this.solicitationInfo.solicitation_status_history && this.solicitationInfo.solicitation_date_history) {
      this.solicitationInfo.solicitation_status_history.split(',').forEach((historyElement, index) => {
        const solicitationPhaseElement = historyElement.split('-')[0];
        const solicitationStatus = historyElement.split('-')[1];
        const assignedDate = this.solicitationInfo.solicitation_date_history.split(',')[index];
        switch (solicitationPhaseElement) {
          case '02':
            this.solicitationInfo.dates = [];
            this.solicitationInfo.dates[0] = assignedDate;
            this.creditGrayZone = true;
            break;
          case '03':
            switch (solicitationStatus) {
              case '06':
                this.solicitationInfo.dates[0] = assignedDate;
                break;
              case '07':
                this.solicitationInfo.dates[1] = assignedDate;
                break;
              case '08':
                this.solicitationInfo.dates[1] = assignedDate;
                break;
            }
            this.creditGrayZone = true;
            break;
          case '04':
            if (solicitationStatus === '05' || solicitationStatus === '09') {
              this.solicitationInfo.dates[2] = assignedDate;
              this.getAnacreResponse();
            }
            this.creditGrayZone = true;
            break;
          case '07':
            this.creditGrayZone = false;
            break;
          case '08':
            this.creditGrayZone = false;
            break;
          case '09':
            this.creditGrayZone = false;
            break;
          case '10':
            /* istanbul ignore next */
            if (solicitationStatus === '10') {
              this.solicitationInfo.dates[3] = assignedDate;
            }
            break;
          case '11':
            /* istanbul ignore next */
            if (solicitationStatus === '10') {
              this.solicitationInfo.dates[2] = assignedDate;
            }
            break;
        }
      });
    }
    if (this.solicitationInfo.solicitation_phase === '02') {
      this.solicitationInfo.dates[0] = '';
    }
    this.currentStep =
    !this.creditGrayZone ? (solicitationPhase === '07' || solicitationPhase === '08' || solicitationPhase === '09') ? -1
    : solicitationPhase === '11' ? 2 : 3
    : this.solicitationInfo.dates[3] ? 3
      : this.solicitationInfo.dates[2] ? 2
        : this.solicitationInfo.dates[1] ? 1 : 0;

    if (!this.creditGrayZone) {
      this.productsOrder = this.productsOrder.concat(this.parameterService.getSetting(OpEnum.PORTAL_OPERATOR_SUMMARY).productsOrderPasive);
    }
    this.creationDate = this.solicitationInfo.solicitation_date_history ?
    this.solicitationInfo.solicitation_date_history.split(',')[0] : new Date().toISOString();
  }

  setProductOrder() {
    this.temporalProducts = [];
    for (const order of this.productsOrder) {
      for (const product of this.solicitationInfo.products) {
        if (product.product_type === order) {
          this.temporalProducts.push(product);
        }
      }
    }
    this.solicitationInfo.products = this.temporalProducts;
  }

  getRejectedDocuments() {
    this.rejectedDocuments = [];
    if (typeof this.solicitationInfo.credit_analisys === 'undefined') { return; }
    const rejectedDocumentsText = this.solicitationInfo.credit_analisys
      .find(element => element.key === 'DOCUMENTOS');
    if (!rejectedDocumentsText) { return; }
    const rejectedDocumentsParts = rejectedDocumentsText.name.split(' \n');
    let documentsElement = {
      name: '',
      reasons: '',
    };
    rejectedDocumentsParts.forEach((element, index) => {
      if ((element.includes(this.copyService.copies.portal_operator_summary.rejected_document_name_util)
        && index !== 0) || element === '') {
        this.rejectedDocuments.push(documentsElement);
        documentsElement = {
          name: '',
          reasons: '',
        };
      }
      if (element.includes(this.copyService.copies.portal_operator_summary.rejected_document_name_util)) {
        documentsElement.name = element.split(this.copyService.copies.portal_operator_summary.rejected_document_name_util)[1]
        .split(this.copyService.copies.portal_operator_summary.rejected_document_name_util_2)[0];
      }
      if (!element.includes(this.copyService.copies.portal_operator_summary.rejected_document_name_util_1)) {return; }
      if (!documentsElement.reasons) {
        documentsElement.reasons = element.split(this.copyService.copies.portal_operator_summary.rejected_document_name_util_1)[1]
      .split(':')[0];
      } else {
        documentsElement.reasons += ', '
        + element.split(this.copyService.copies.portal_operator_summary.rejected_document_name_util_1)[1]
      .split(':')[0];
      }
    });
  }

  getAnacreResponse() {
    if (typeof this.solicitationInfo.credit_analisys === 'undefined') { return; }
    const creditResponse = this.solicitationInfo.credit_analisys
      .find(element => element.key === 'RESPUESTA');
    if (!creditResponse) { return; }
    this.anacreResponse = creditResponse.name;
  }

  formatDate(date: string) {
    const mydate = new Date(date);
    let day = mydate.getDate().toString();
    let month = (mydate.getMonth() + 1).toString();
    const year = mydate.getFullYear();
    if (+day < 10) {
      day = `0${day}`;
    }
    if (+month < 10) {
      month = `0${month}`;
    }
    return `${day}/${month}/${year}`;
    // return date ? date.split('T')[0].replace(new RegExp('-', 'g'), '/') : '';
  }

  formatNumberAsCurrency(number: string) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  taggEvent(tag_number: string, description?: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes = this.taggingService.createTagChanges(tagPageName, tag_number);
      if (EVENT[`${tagPageName}E${tag_number}setData`][`${tagPageName}E${tag_number}transactionProductDetails`]) {
        changes.push({
          path: EVENT[`${tagPageName}E${tag_number}setData`][`${tagPageName}E${tag_number}transactionProductDetails`].path,
          value: this.navigationService.camelize(description ? description : ''),
        }) ;
      }
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E${tag_number}customLabel`],
      };
      switch (tag_number) {
        case '2':
          event.category = {
            module: EVENT.customCategory.module.body,
            type: EVENT.customCategory.type.button,
            position: EVENT.customCategory.position.center,
          };
          event.action = EVENT.customAction.click;
          break;
        case '3':
          event.category = {
            module: EVENT.customCategory.module.body,
            type: EVENT.customCategory.type.link,
            position: EVENT.customCategory.position.center,
          };
          event.action = EVENT.customAction.click;
          break;
        case '4':
          event.category = {
            module: EVENT.customCategory.module.body,
            type: EVENT.customCategory.type.warning,
            position: EVENT.customCategory.position.top,
          };
          event.action = EVENT.customAction.show;
          break;
      }
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(`Error enn ${error}`);
    }
  }
}
